export function downloadContent(prefix: string, response: Blob): void {
  const dataType = response.type;
  const binaryData = [response];
  const downloadLink = document.createElement('a');
  downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
  downloadLink.setAttribute('download', `${prefix}_${Date.now()}.xlsx`);
  document.body.appendChild(downloadLink);
  downloadLink.click();
}
